export enum AccountTypes {
  PARTNER = "PARTNER",
  RESELLER = "RESELLER",
  MERCHANT = "MERCHANT",
  MERCHANT_BRANCH = "MERCHANT_BRANCH",
  MARKETING = "MARKETING",
}
